import { Tooltip } from 'antd';
import React from 'react';
import { Recipient } from '@/apis/types';

interface RecipientsDisplayProps {
  recipients?: Recipient[];
}

const RecipientsDisplay: React.FC<RecipientsDisplayProps> = ({
  recipients = [],
}) => {
  if (recipients.length === 0) return null;

  if (recipients.length === 1) {
    const recipient = recipients[0];
    return (
      <span>
        {recipient?.name}
        {recipient?.contact ? ` (${recipient.contact})` : ''}
      </span>
    );
  }

  const [first, ...rest] = recipients;
  return (
    <span>
      {first?.name}
      {first?.contact ? ` (${first.contact})` : ''}
      <Tooltip
        title={rest.map((r) => (
          <div key={r?.id ?? r?.name}>
            {r?.name}
            {r?.contact ? ` (${r.contact})` : ''}
          </div>
        ))}
      >
        <span className='cursor-pointer'>+{rest.length}</span>
      </Tooltip>
    </span>
  );
};

export interface CustomerNotificationCOCData {
  id: string;
  triggered_by: string;
  message?: string;
  recipients?: Recipient[];
  notification_method?: string;
  link_opened?: boolean;
  open_count?: number;
  follow_on_alerts_label?: string | null;
}

interface CustomerNotificationCOCRowProps {
  data: CustomerNotificationCOCData;
  parentRef: React.RefObject<HTMLParagraphElement | HTMLDivElement | null>;
  repliesRef: React.RefObject<HTMLParagraphElement | HTMLDivElement | null>;
}

const CustomerNotificationCOCRow: React.FC<CustomerNotificationCOCRowProps> = ({
  data,
  parentRef,
  repliesRef,
}) => {
  const isSms = data.notification_method === 'SMS';
  const openCount = data.open_count ?? 0;
  const showOpenTracking = Boolean(data.link_opened) && openCount > 0;
  const openLabel = isSms
    ? `Tracking link opened (${openCount} time${openCount === 1 ? '' : 's'})`
    : `Email opened (${openCount} time${openCount === 1 ? '' : 's'})`;
  const followOnLabel = data.follow_on_alerts_label?.trim() || '';

  return (
    <div>
      <p ref={parentRef} className='zl-para-12 coc-comment-editor mt-1'>
        Triggered by {data.triggered_by} →{' '}
        <RecipientsDisplay recipients={data.recipients} />
      </p>

      <div className='mt-2 one-time-message-wrapper flex-center y btw color-black coc-comment-editor zl-para-12'>
        <p ref={repliesRef}>Message: {data.message ?? ''}</p>
      </div>

      {showOpenTracking && (
        <p
          className='zl-para-12 mt-1'
          style={{ color: 'var(--text-secondary)' }}
        >
          {openLabel}
        </p>
      )}

      {followOnLabel ? (
        <p
          className='zl-para-12 mt-1'
          style={{ color: 'var(--text-secondary)' }}
        >
          {followOnLabel}
        </p>
      ) : null}
    </div>
  );
};

export default CustomerNotificationCOCRow;
